import { atom } from "jotai";

export const setToRotateAtom = atom<any | null>(null);